import React, { Component } from 'react';

class Portfolio extends Component {
  render() {
    const { data, isCert } = this.props
    if (data) {
      var projects = data.projects.map(function (project_item) {
        var projectImage = 'images/portfolio/' + project_item.image;
        return <div key={project_item.title} className="columns portfolio-item">
          <div className="item-wrap">
            {
              (project_item.url && project_item.url !== '')
                ?
                <a href={project_item.url} title={project_item.title}>
                  <img alt={project_item.title} src={projectImage} />
                  <div className="overlay">
                    <div className="portfolio-item-meta">
                      <h5>{project_item.title}</h5>
                      <p>{project_item.category}</p>
                    </div>
                  </div>
                  <div className="link-icon"><i className="fa fa-link"></i></div>
                </a>
                :
                <>
                  <img alt={project_item.title} src={projectImage} />
                  <div className="overlay">
                    <div className="portfolio-item-meta">
                      <h5>{project_item.title}</h5>
                      <p>{project_item.category}</p>
                    </div>
                  </div>
                </>
            }
          </div>
        </div>
      })
    }

    return (
      (isCert)
        ?
        <section id="cert">

          <div className="row">

            <div className="twelve columns collapsed">

              <h4 style={{ color: "white", textAlign: "center" }}><u>免許・資格の一覧：</u></h4>

              <div id="portfolio-wrapper" className="bgrid-quarters s-bgrid-thirds cf">
                {projects}
              </div>
            </div>
          </div>
        </section>
        :
        <section id="portfolio">

          <div className="row">

            <div className="twelve columns collapsed">

              <h1><u>研修で作ったプロジェクトの成果物一覧：</u></h1>

              <div id="portfolio-wrapper" className="bgrid-quarters s-bgrid-thirds cf">
                {projects}
              </div>
            </div>
          </div>
        </section>
    );
  }
}

export default Portfolio;
